export enum LoginContent {
	LOGIN,
	SUPPORT_OPTIONS,
	SECURE_LOG_IN,
}
